import { render, staticRenderFns } from "./OnboardingExitGuard.vue?vue&type=template&id=79a9bc6c&"
import script from "./OnboardingExitGuard.vue?vue&type=script&lang=js&"
export * from "./OnboardingExitGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports